import React from "react";
import ReactBubbleChart from "../../../components/Bubble/index";
import PropTypes from "prop-types";
import BubbleInfoSection from "./BubbleInfoSection";

const BubbleSection = ({
  doc,
  info,
  onClickCallBack,
  english,
  investment,
  title,
}) => {
  let largestBubble = 0;
  const themes = {
    Industri: "#D2190B",
    Industrials: "#D2190B",
    Telekommunikasjon: "#F35037",
    Telecommunications: "#F35037",
    Technology: "#F35E37",
    Energy: "#F26B38",
    "Consumer services": "#F27938",
    Financials: "#F18639",
    "Basic materials": "#F19439",
    "Consumer goods": "#F0A13A",
  };

  const parseBubbles = (english) => {
    var bubblesToReturn = [];
    if (doc != null) {
      if (english) {
        doc.forEach((bubble) => {
          if (bubble.investment_size_usd.length) {
            const value = bubble.involvement * 6.5;
            largestBubble = Math.max(value, largestBubble);
            if (!isNaN(value)) {
              bubblesToReturn.push({
                [bubble.title[0].text]: value,
                sector: bubble.sector[0].text,
              });
            }
          }
        });
      } else {
        doc.forEach((bubble) => {
          if (bubble.investment_size.length) {
            const value = bubble.involvement * 6.5;
            largestBubble = Math.max(value, largestBubble);
            if (!isNaN(value)) {
              bubblesToReturn.push({
                [bubble.title[0].text]: value,
                sector: bubble.sector[0].text,
              });
            }
          }
        });
      }
    }
    return bubblesToReturn;
  };

  // const scaleBubbles = (bubbles) => {
  //   var bubblesToReturn = [];
  //   if (bubbles.length) {
  //     bubblesToReturn = bubbles.map((bubble) => {
  //       const currentBubbleKey = Object.keys(bubble)[0];
  //       const scaledValue = Math.min(
  //         90,
  //         Math.max(15, (Object.values(bubble)[0] / largestBubble) * 100)
  //       );
  //       return { [currentBubbleKey]: scaledValue, sector: bubble.sector };
  //     });
  //     return bubblesToReturn;
  //   }
  // };

  const allBubbles = parseBubbles(english);
  //const scaledBubbles = scaleBubbles(allBubbles);
  return (
    <div
      style={{
        display: "inline-flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      {doc && (
        <ReactBubbleChart
          center={{ x: "300", y: "300" }}
          data={allBubbles.map((item, index) => ({
            index: index,
            name: Object.keys(item)[0],
            color: themes[item.sector] || "#f1c453",
            radius: Object.values(item)[0],
          }))}
          width={600}
          height={600}
          onClickCallBack={onClickCallBack}
        />
      )}
      <BubbleInfoSection
        info={info}
        investment={investment}
        english={english}
        title={title}
      />
    </div>
  );
};

BubbleSection.propTypes = {
  name: PropTypes.string,
  doc: PropTypes.array,
  onClickCallBack: PropTypes.func,
  info: PropTypes.string,
  english: PropTypes.bool,
  investment: PropTypes.string,
  title: PropTypes.string,
};

export default BubbleSection;
